<template>
  <div :style="{'max-width': width + 'px'}" class="wrapper">
    <div v-if="!editing">{{prefix}}</div>
    <button class="editable-text" @click="startEditing()" v-show="!editing">{{value}}</button>
    <v-text-field
      :type="type"
      :rules="rules"
      :prefix="prefix"
      color="blue"
      v-show="editing"
      v-model="editedValue"
      ref="field"
      @blur="saveChanges()"
    >
      <!-- <template v-slot:append v-if="this.originalValue !== this.editedValue">
        <v-btn icon color="red lighten-3" small @click="revertChanges()">
          <v-icon>mdi-undo-variant</v-icon>
        </v-btn>
      </template>-->
    </v-text-field>
  </div>
</template>


<script>
export default {
  props: {
    prefix: String,
    rules: Array,
    type: String,
    width: Number,
    value: String
  },
  data() {
    return {
      editing: false,
      editedValue: null,
      originalValue: null
    }
  },
  methods: {
    startEditing() {
      this.editing = true
      this.$nextTick(() => this.$refs.field.focus())
    },
    revertChanges() {
      this.editedValue = this.originalValue
    },
    saveChanges() {
      this.$refs.field.blur()
      this.editing = false
      this.$emit('valueChanged', this.editedValue)
    }
  },

  mounted() {
    this.originalValue = this.value
    this.editedValue = this.originalValue
  }
}
</script>

<style lang="sass" scoped>
.wrapper
    display: flex
    flex-direction: row

button.editable-text
    background: none
    border: none
</style>